import { ACTIONS_ACTIONS } from "./constants";

const initialState = {
  actions: [],
  isFetching: false,
  error: null,
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS_ACTIONS.list.request:
      return {
        ...state,
        isFetching: true,
      };
    case ACTIONS_ACTIONS.list.success:
      return {
        ...state,
        isFetching: true,
        actions: action.payload,
      };
    case ACTIONS_ACTIONS.list.error:
      return {
        ...state,
        actions: [],
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducers;
